import { api } from "./apiClient";

export const notificationsAPI = {
    list: (limit = 50) => api.get(`/notifications?limit=${limit}`),
    unreadCount: () => api.get("/notifications/unread-count"),
    markAllRead: () => api.patch("/notifications/read-all"),
    markRead: (id) => api.patch(`/notifications/${id}/read`),
};
